import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "m4.29 4.914 3.062 2.379c1.23-.93 2.761-1.668 4.648-1.668 2.188 0 3.965 1.012 5.25 2.215 1.285 1.176 2.133 2.598 2.543 3.582a.98.98 0 0 1 0 .683c-.355.875-1.094 2.133-2.187 3.227l2.87 2.27c.301.218.356.628.11.902a.604.604 0 0 1-.902.11L3.496 5.925a.604.604 0 0 1-.11-.903.604.604 0 0 1 .903-.109m5.058 3.938 2.46 1.941c.11-.246.192-.492.192-.766 0-.218-.055-.382-.11-.574-.027-.137.055-.328.22-.3 1.12.027 2.105.792 2.406 1.94.164.602.109 1.204-.11 1.723l1.04.82c.3-.546.492-1.202.492-1.886 0-2.16-1.778-3.937-3.938-3.937-1.04 0-1.969.41-2.652 1.039m4.101 6.562L15.445 17a7.16 7.16 0 0 1-3.445.875c-2.215 0-3.992-.984-5.277-2.187-1.285-1.204-2.133-2.626-2.543-3.583a.98.98 0 0 1 0-.683A11 11 0 0 1 5.52 9.18l2.57 2.023c-.027.192-.027.383-.027.547A3.92 3.92 0 0 0 12 15.688a3.8 3.8 0 0 0 1.45-.274"
    }, null, -1)
  ]))]))
}
export default { render: render }